<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="700">
      <v-card>
        <v-card-title class="white--text py-4 px-5" style="background: linear-gradient(135deg, #1a73e8, #0d47a1);">
          <v-icon left color="white">mdi-file-document-outline</v-icon>
          <span class="text-h6 font-weight-bold">Contrat Hellio</span>
        </v-card-title>

        <v-card-text class="pa-5">
          <!-- Offer info block -->
          <div class="rounded-lg pa-4 mb-4" style="background-color: #f0f4ff; border-left: 4px solid #1a73e8;">
            <div class="caption font-weight-bold text-uppercase mb-3" style="color: #1a73e8; letter-spacing: 0.08em;">
              Informations de l'offre
            </div>
            <v-row dense>
              <v-col cols="6">
                <div class="caption mb-1" style="color: #8a9bb0;">ID Offre</div>
                <div class="body-2 font-weight-bold" style="color: #1a237e;">{{ $props.donner['contractData'].offerId }}</div>
              </v-col>
              <v-col cols="6">
                <div class="caption mb-1" style="color: #8a9bb0;">Marge</div>
                <div class="body-2 font-weight-bold" style="color: #1a237e;">
                  {{ $props.donner['contractData'].marge }}
                  <span class="caption" style="color:#1a73e8;">€/MWh</span>
                </div>
              </v-col>
            </v-row>
          </div>

          <!-- Signatory block -->
          <div class="rounded-lg pa-4 mb-4" style="background-color: #f5f5f5; border-left: 4px solid #546e7a;">
            <div class="caption font-weight-bold text-uppercase mb-3" style="color: #546e7a; letter-spacing: 0.08em;">
              Signataire
            </div>
            <v-row dense>
              <v-col cols="6">
                <div class="caption mb-1" style="color: #8a9bb0;">Prénom</div>
                <div class="body-2 font-weight-medium">{{ $props.donner['contractData'].signatory.firstname }}</div>
              </v-col>
              <v-col cols="6">
                <div class="caption mb-1" style="color: #8a9bb0;">Nom</div>
                <div class="body-2 font-weight-medium">{{ $props.donner['contractData'].signatory.lastname }}</div>
              </v-col>
              <v-col cols="12" class="mt-2">
                <div class="caption mb-1" style="color: #8a9bb0;">Email</div>
                <div class="body-2 font-weight-medium">{{ $props.donner['contractData'].signatory.email }}</div>
              </v-col>
              <v-col cols="6" class="mt-2">
                <div class="caption mb-1" style="color: #8a9bb0;">Téléphone</div>
                <div class="body-2 font-weight-medium">{{ $props.donner['contractData'].signatory.phone }}</div>
              </v-col>
              <v-col cols="6" class="mt-2">
                <div class="caption mb-1" style="color: #8a9bb0;">Rôle</div>
                <div class="body-2 font-weight-medium">{{ $props.donner['contractData'].signatory.role }}</div>
              </v-col>
            </v-row>
          </div>

          <!-- Valider: loading / error / success feedback -->
          <div v-if="loadingContract" class="text-center py-3">
            <v-progress-circular :size="40" :width="4" color="primary" indeterminate />
            <div class="mt-2 caption" style="color: #8a9bb0;">Validation en cours...</div>
          </div>
          <v-alert v-else-if="contractError" type="error" outlined dense class="mb-2 rounded-lg">
            {{ contractError }}
            <div class="mt-1">
              <v-btn small text color="error" @click="validerOffre">
                <v-icon left small>mdi-refresh</v-icon>Réessayer
              </v-btn>
            </div>
          </v-alert>
          <v-alert v-else-if="contractData" type="success" outlined dense class="mb-2 rounded-lg">
            Offre validée — réf. <strong>{{ contractData.contractReference }}</strong>
          </v-alert>

          <!-- Download: loading / error / success feedback -->
          <div v-if="loadingDownload" class="text-center py-3">
            <v-progress-circular :size="40" :width="4" color="green darken-1" indeterminate />
            <div class="mt-2 caption" style="color: #8a9bb0;">Téléchargement en cours...</div>
            <v-progress-linear indeterminate color="green darken-1" class="mt-2 rounded" height="4" />
          </div>
          <v-alert v-else-if="downloadError" type="warning" outlined dense class="mb-2 rounded-lg">
            {{ downloadError }}
            <div class="mt-1">
              <v-btn small text color="warning" @click="downloadContract">
                <v-icon left small>mdi-refresh</v-icon>Réessayer
              </v-btn>
            </div>
          </v-alert>
          <v-alert v-else-if="downloadSuccess" type="success" outlined dense class="mb-0 rounded-lg">
            <v-icon left small>mdi-check-circle</v-icon>
            Fichier téléchargé : <em>{{ downloadedFileName }}</em>
          </v-alert>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-btn
            text
            color="grey darken-1"
            :disabled="loadingContract || loadingDownload"
            @click="dialog = false"
          >
            Fermer
          </v-btn>

          <v-spacer />

          <v-btn
            v-if="!($props.donner?.contractId)"
            color="primary"
            :loading="loadingContract"
            :disabled="loadingContract || loadingDownload || !!contractData"
            @click="validerOffre"
          >
            <v-icon left>mdi-check</v-icon>
            Valider l'offre
          </v-btn>

          <v-btn
            v-if="$props.donner?.contractId"
            color="green darken-1"
            dark
            :loading="loadingDownload"
            :disabled="loadingDownload || loadingContract"
            @click="downloadContract"
          >
            <v-icon left>mdi-download</v-icon>
            Télécharger le contrat
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Trigger button -->
    <v-btn icon depressed class="ma-auto text-capitalize" @click="openDialog">
      <v-icon :color="$colors[0]">mdi-text-box-edit</v-icon>
    </v-btn>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Hellio',
  props: {
    optionTarifaire: { default: '' },
    donner: { default: null },
    numCompteur: { default: null },
    societe: { default: null },
    donnerEnedis: { default: null },
  },
  data: () => ({
    dialog: false,
    // Valider offre
    loadingContract: false,
    contractError: null,
    contractData: null,
    // Download
    loadingDownload: false,
    downloadError: null,
    downloadSuccess: false,
    downloadedFileName: '',
  }),
  methods: {
    openDialog() {
      this.loadingContract = false
      this.contractError = null
      this.contractData = null
      this.loadingDownload = false
      this.downloadError = null
      this.downloadSuccess = false
      this.downloadedFileName = ''
      this.dialog = true
    },
    async validerOffre() {
      this.loadingContract = true
      this.contractError = null

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_URL_API_CLIENT}getContractHellio/`,
          this.$props.donner['contractData'],
          { timeout: 30000 }
        )

        if (response.data?.result === true && response.data?.data) {
          this.contractData = response.data.data
        } else {
          this.contractError = "Le serveur n'a pas retourné de données valides."
        }
      } catch (err) {
        if (err.code === 'ECONNABORTED') {
          this.contractError = 'La requête a expiré. Vérifiez votre connexion et réessayez.'
        } else if (err.response) {
          this.contractError = `Erreur serveur (${err.response.status}) : ${err.response.data?.message || 'Veuillez réessayer.'}`
        } else if (err.request) {
          this.contractError = 'Impossible de joindre le serveur. Vérifiez votre connexion réseau.'
        } else {
          this.contractError = 'Une erreur inattendue est survenue.'
        }
      } finally {
        this.loadingContract = false
      }
    },
    async downloadContract() {
      this.loadingDownload = true
      this.downloadError = null
      this.downloadSuccess = false

      try {
        const fileId = this.$props.donner?.contractId
        const response = await axios.post(
          `${process.env.VUE_APP_URL_API_CLIENT}getHellioFile/`,
          { fileId },
          { timeout: 60000 }
        )

        if (response.data?.result === true && response.data?.data?.contentBase64) {
          const { name, fileExtension, contentBase64 } = response.data.data
          const byteArray = Uint8Array.from(
            globalThis.atob(contentBase64),
            (c) => c.charCodeAt(0)
          )
          const mimeType = fileExtension === 'pdf' ? 'application/pdf' : 'application/octet-stream'
          const blob = new Blob([byteArray], { type: mimeType })
          const url = URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = name || `contrat-hellio.${fileExtension || 'pdf'}`
          link.click()
          URL.revokeObjectURL(url)
          this.downloadSuccess = true
          this.downloadedFileName = name || `contrat-hellio.${fileExtension}`
        } else {
          this.downloadError = "Le serveur n'a pas retourné de fichier valide."
        }
      } catch (err) {
        if (err.code === 'ECONNABORTED') {
          this.downloadError = 'Le téléchargement a expiré (connexion lente ?). Réessayez.'
        } else if (err.response) {
          this.downloadError = `Erreur serveur (${err.response.status}) : ${err.response.data?.message || 'Veuillez réessayer.'}`
        } else if (err.request) {
          this.downloadError = 'Impossible de joindre le serveur. Vérifiez votre connexion réseau.'
        } else {
          this.downloadError = 'Une erreur inattendue est survenue lors du téléchargement.'
        }
      } finally {
        this.loadingDownload = false
      }
    },
  },
}
</script>
